import { Typography } from '@branchjs/neo-components';
import React from 'react';
import { appEntryStyles } from './AppEntry.styles';

const AppEntry = ({ type, active, text }: { type: 'disco' | 'saas'; active?: boolean; text?: string }) => {
  const { discoTile, saasTile, activeTile, content } = appEntryStyles;
  if (type === 'saas') {
    return (
      <div className={active ? activeTile : content}>
        <div className={saasTile}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.1699 17H2.16992V5H12.1699V6H14.1699V2C14.1699 0.9 13.2699 0 12.1699 0H2.16992C1.06992 0 0.169922 0.9 0.169922 2V20C0.169922 21.1 1.06992 22 2.16992 22H12.1699C13.2699 22 14.1699 21.1 14.1699 20V16H12.1699V17Z"
                fill="white"
              />
              <path
                d="M15.5499 8.62L15.9499 9.49C16.0399 9.69 16.3199 9.69 16.4099 9.49L16.8099 8.62L17.6799 8.22C17.8799 8.13 17.8799 7.85 17.6799 7.76L16.8099 7.36L16.4099 6.49C16.3199 6.29 16.0399 6.29 15.9499 6.49L15.5499 7.36L14.6799 7.76C14.4799 7.85 14.4799 8.13 14.6799 8.22L15.5499 8.62Z"
                fill="white"
              />
              <path
                d="M10.7099 8L9.91992 9.75L8.16992 10.54C7.77992 10.72 7.77992 11.27 8.16992 11.45L9.91992 12.24L10.7099 14C10.8899 14.39 11.4399 14.39 11.6199 14L12.4099 12.25L14.1699 11.46C14.5599 11.28 14.5599 10.73 14.1699 10.55L12.4199 9.76L11.6299 8C11.4499 7.61 10.8899 7.61 10.7099 8Z"
                fill="white"
              />
              <path
                d="M15.9399 12.5L15.5399 13.37L14.6699 13.77C14.4699 13.86 14.4699 14.14 14.6699 14.23L15.5399 14.63L15.9399 15.5C16.0299 15.7 16.3099 15.7 16.3999 15.5L16.7999 14.63L17.6699 14.23C17.8699 14.14 17.8699 13.86 17.6699 13.77L16.7999 13.37L16.3999 12.5C16.3099 12.31 16.0299 12.31 15.9399 12.5Z"
                fill="white"
              />
            </svg>
          </svg>
        </div>
        <Typography variant="subtitle1">{text}</Typography>
      </div>
    );
  }

  return (
    <div className={active ? activeTile : content}>
      <div className={discoTile}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM14.5 14H6C4.34 14 3 12.66 3 11C3 9.34 4.34 8 6 8H6.14C6.58 6.27 8.13 5 10 5C12.21 5 14 6.79 14 9H14.5C15.88 9 17 10.12 17 11.5C17 12.88 15.88 14 14.5 14Z"
            fill="white"
          />
        </svg>
      </div>
      <Typography variant="subtitle1">{text}</Typography>
    </div>
  );
};

export default AppEntry;
